import React from 'react';

const Language = (props) => {
  return (
    <div className="serviceInfo">
      <span className="serviceInfoContainer">
        <h3 className="serviceTitle">Sorry... Under Construction...</h3>
      </span>
    </div>
  );
};


export default Language;
